/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  OkrKeyResultDto,
  OkrObjectivesWithDetailForManager,
  OkrObjectivesWithDetail,
} from './models';

/**
 * OkrKeyResultApi - API class
 */
export class OkrKeyResultApi extends LinqService {

  /**
   * Creates a new OkrKeyResultApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: OkrKeyResultDto, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/GetAsync`;
    let query = this.createQuery<OkrKeyResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  getOkrKeyResultWithEmployeeAsync(okrPeriodIds?: Array<string>, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/GetOkrKeyResultWithEmployeeAsync`;
    let query = this.createQuery<OkrObjectivesWithDetail>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    options.data = okrPeriodIds
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param employeeId 
   */
  getOkrObjectiveByManagerIdAsync(employeeId?: string, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/GetOkrObjectiveByManagerIdAsync`;
    let query = this.createQuery<OkrObjectivesWithDetailForManager>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'employeeId', value: employeeId && employeeId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param teamId 
   */
  getOkrObjectiveByTeamIdAsync(teamId?: string, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/GetOkrObjectiveByTeamIdAsync`;
    let query = this.createQuery<OkrObjectivesWithDetail>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'teamId', value: teamId && teamId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/GetTranslatedAsync`;
    let query = this.createQuery<OkrKeyResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/List`;
    let query = this.createQuery<OkrKeyResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/ListTranslated`;
    let query = this.createQuery<OkrKeyResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: OkrKeyResultDto, options?: QueryOptions) {
    // create query
    const url = `/OkrKeyResult/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
